const CustomerCellRenderer = (params) => {
  try {
    const { colDef, data } = params;
    const { customers, customer, customer_name } = data;

    if (colDef.attribute_type === "company_name") {
      return customers?.company_name;
    }

    if (colDef.attribute_type === "customer") {
      return customer || "";
    }

    if (colDef.attribute_type === "customer_type") {
      return customers?.account_type;
    }
    if (colDef.attribute_type === "name") {
      return customer_name || "";
    }

    if (colDef.attribute_type === "product") {
      const { options } = colDef;
      return options.find((item) => item?.id === customers?.product)?.value;
    }
  } catch (err) {
    console.log(err.message);
  }
};
export default CustomerCellRenderer;
